import React, { useState, useRef, useEffect, useCallback } from "react";
import ReactMarkdown from "react-markdown";
import store from "../../../../store/store";
import { BrComerceApiService } from "../../../../services/BrComerceApiService";
import styles from "./styles.module.scss";

const AnnouncementModal = () => {
  const api = new BrComerceApiService();

  const [announcement, setAnnouncement] = useState(null);
  const [visible, setVisible] = useState(false);
  const [reachedEnd, setReachedEnd] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const fetchActiveAnnouncement = async () => {
      const { auth } = store.getState();
      
      if (!auth || !auth.user) return;

      try {
        const response = await api.makeHttpRequest({
          method: "GET",
          url: "/announcements/active"
        });

        if (response && response.id) {
          setAnnouncement(response);
          setVisible(true);
        }
      } catch (error) {
        console.error("Erro ao buscar anúncios ativos", error);
      }
    };

    fetchActiveAnnouncement();
  }, []);

  useEffect(() => {
    if (!visible || !announcement) return;

    setTimeout(() => {
      const el = contentRef.current;
      if (!el) return;
      if (el.scrollHeight - el.clientHeight < 30) {
        setReachedEnd(true);
      }
    }, 100);
  }, [visible, announcement]);

  const handleScroll = useCallback(() => {
    const el = contentRef.current;
    if (!el) return;
    const isAtBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 30;
    if (isAtBottom) {
      setReachedEnd(true);
    }
  }, []);

  const handleClose = async () => {
    if (dontShowAgain && announcement) {
      try {
        await api.makeHttpRequest({
          method: "POST",
          url: `/announcements/${announcement.id}/read`
        });
      } catch (error) {
        console.error("Erro ao registrar leitura do anúncio", error);
      }
    }
    setVisible(false);
  };

  const getSeverityStyle = severity => {
    switch (severity) {
      case "Crítico":
        return { color: "#d93025", icon: "🚨" };
      case "Aviso":
        return { color: "#f29900", icon: "⚠️" };
      case "Informação":
      default:
        return { color: "#1a7f37", icon: "📢" };
    }
  };

  if (!visible || !announcement) return null;

  const styleProps = getSeverityStyle(announcement.severity);

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2>Comunicado</h2>
        </div>
        <div
          className={styles.content}
          ref={contentRef}
          onScroll={handleScroll}
        >
          <h1
            style={{
              color: styleProps.color,
              borderBottom: `3px solid ${styleProps.color}`,
              paddingBottom: 10,
              fontSize: "1.5em",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}
          >
            {styleProps.icon} {announcement.title}
          </h1>

          <div style={{ marginTop: "20px" }}>
            <ReactMarkdown>{announcement.content}</ReactMarkdown>
          </div>

          {!reachedEnd && (
            <p
              style={{
                textAlign: "center",
                color: "#999",
                marginTop: 20,
                fontSize: 13
              }}
            >
              Role até o final para habilitar o botão de fechar
            </p>
          )}
        </div>
        <div className={styles.footer}>
          <label className={styles.checkbox}>
            <input
              type="checkbox"
              checked={dontShowAgain}
              onChange={() => setDontShowAgain(!dontShowAgain)}
            />
            <span>Não exibir novamente</span>
          </label>
          <button
            className={styles.closeButton}
            disabled={!reachedEnd}
            onClick={handleClose}
            style={{
              backgroundColor: reachedEnd ? styleProps.color : "#ccc",
              cursor: reachedEnd ? "pointer" : "not-allowed"
            }}
          >
            {reachedEnd ? "Entendi" : "Role até o final"}
          </button>
        </div>
      </div>
    </div>
  );
};

export { AnnouncementModal };
